export default {
	align: true
};
